var Vue = require("vue/dist/vue.min.js");
var data = require("../../data/preprocessed.sheet.json");
var card = require("./card")
var locator = require("./locator")
var shuffle = require('./lib/shuffle')
var VueLazyload = require('vue-lazyload')

var allTags = data.allTags;
var neighborhoods = data.neighborhoods;
var mainTags = data.mainTags;
var secondaryTags = data.secondaryTags;
var recs = data.recs;

const renderApp = () => {

    var shuffledList= shuffle(recs.slice())

    Vue.use(VueLazyload, {
        lazyComponent: true
    });
        
    Vue.component('card', card())
    Vue.component('locator', locator())

    var app = new Vue({
        el: '#app',
        template: require('./_app.html'),
        data: {
            allTags: allTags,
            mainTags: mainTags,
            secondaryTags: secondaryTags,
            activeTags: [],
            recs: shuffledList,
            neighborhoods: neighborhoods,
            moreFilters: false,
            showFilters: false
        },
        computed: {
            activeRecs: function() {
                if (this.activeTags.length && this.activeNeighborhoods.length) {
                    
                    // Return results for all neighborhoods selected
                    let a = this.recs.filter(function(card){
                        if (card.tags) {
                            return app.activeNeighborhoods.some(function(t) {
                                return card.tags.indexOf(t) >= 0;
                            })
                        } else {
                            return false;
                        }
                    });

                   // then return results for other active tags
                    return filterList(a, this.activeDescriptions);
                } else if (this.activeTags.length) {
                    return filterList(this.recs, this.activeDescriptions);
                } else {
                    return this.recs
                }
            },
            activeNeighborhoods: function() {
                return this.activeTags.filter(t=> this.neighborhoods.includes(t))
            },
            activeDescriptions: function() {
                let activeMain = this.activeTags.filter(t=> this.mainTags.includes(t));
                let activeSecondary= this.activeTags.filter(t=> this.secondaryTags.includes(t));
                return activeMain.concat(activeSecondary)
            }
       }
    });
}


const filterList = (list, activeTags) => {
    return list.filter(function(card) {
        if (card.tags) {
            return activeTags.every( c => card.tags.includes(c))
        } else {
            return false
        }
    })
  }

renderApp();